import type { SVGProps } from 'react';
import * as React from 'react';

const SvgSunrise = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 16 16" {...props}>
    <path
      d="M8 2.628a.667.667 0 0 0 .667-.667V.788a.667.667 0 0 0-1.334 0v1.173c0 .368.299.667.667.667M13.371 8.014c0 .368.299.667.667.667h1.173a.667.667 0 0 0 0-1.334h-1.173a.667.667 0 0 0-.667.667M.789 8.681h1.173a.667.667 0 0 0 0-1.334H.789a.667.667 0 0 0 0 1.334M3.252 4.208a.665.665 0 0 0 .942 0 .668.668 0 0 0 0-.943l-.829-.829a.668.668 0 0 0-.943.943zM12.277 4.404a.663.663 0 0 0 .471-.195l.829-.829a.668.668 0 0 0-.943-.943l-.829.829a.668.668 0 0 0 .471 1.138ZM3.968 9.823a.665.665 0 1 0 1.214-.55 3.095 3.095 0 0 1 2.817-4.366 3.095 3.095 0 0 1 2.817 4.366.667.667 0 1 0 1.214.549 4.429 4.429 0 0 0-4.031-6.248 4.43 4.43 0 0 0-4.031 6.248Z"
      fill="currentColor"
    />
    <path
      d="M15.211 12H10.79L8.471 9.681a.668.668 0 0 0-.943 0L5.209 12H.789a.667.667 0 0 0 0 1.334h4.697c.177 0 .346-.07.471-.195L8 11.096l2.043 2.043a.667.667 0 0 0 .471.195h4.697a.667.667 0 0 0 0-1.334"
      fill="currentColor"
    />
  </svg>
);
export default SvgSunrise;
